<template>
  <form @submit="save">
    <div>
      <label class="block mb-2 text-grey-darkest text-lg font-normal">Title:</label>
      <pl-select v-model="user.title" class="w-full" required>
        <option disabled selected :value="null">Please Select</option>
        <option>Mr</option>
        <option>Mrs</option>
        <option>Miss</option>
        <option>Ms</option>
        <option>Dr</option>
      </pl-select>
      <small v-if="errors.get('title')" class="block mt-2 text-red-dark">
        {{ errors.get('title') }}
      </small>
    </div>
    <div class="mt-4">
      <label class="block mb-2 text-grey-darkest text-lg font-normal">Name:</label>
      <input
        v-model="user.first_name"
        type="text"
        placeholder="Forename"
        class="input w-full mb-3"
        required
      >
      <input
        v-model="user.surname"
        type="text"
        placeholder="Surname"
        class="input w-full mb-3"
        required
      >
      <small v-if="errors.get('first_name') || errors.get('surname')" class="block mt-2 text-red-dark">
        Please enter a full name
      </small>
    </div>
    <div class="mt-4">
      <label class="block mb-2 text-grey-darkest text-lg font-normal">Email:</label>
      <input
        v-model="user.email"
        type="email"
        placeholder="Email"
        class="input w-full mb-3"
        required
      >
      <small v-if="errors.get('email')" class="block mt-2 text-red-dark">
        {{ errors.get('email') }}
      </small>
    </div>
    <div class="mt-4">
      <label class="block mb-2 text-grey-darkest text-lg font-normal">Contact Number:</label>
      <input
        v-model="user.phone"
        type="text"
        placeholder="Contact Number"
        class="input w-full mb-3"
        maxlength="32"
      >
    </div>
    <div class="mt-4">
      <label class="block mb-2 text-grey-darkest text-lg font-normal">Mobile Number:</label>
      <input
        v-model="user.mobile"
        type="text"
        placeholder="Mobile Number"
        class="input w-full mb-3"
        maxlength="32"
      >
    </div>
    <div class="mt-4" v-if="!user.id">
      <label class="block mb-2 text-grey-darkest text-lg font-normal">Password:</label>
      <input
        v-model="user.password"
        type="password"
        placeholder="Password"
        class="input w-full mb-3"
        required
      >
      <input
        v-model="user.password_confirmation"
        type="password"
        placeholder="Confirm Password"
        class="input w-full mb-3"
        required
      >
      <small v-if="errors.get('password')" class="block mt-2 text-red-dark">
        {{ errors.get('password') }}
      </small>
    </div>
    <div class="mt-4 flex flex-wrap">
      <div class="w-full md:w-1/3" v-if="systemsAvailable.indexOf('referrals') !== -1">
        <input id="referral_system_user" class="mr-2 leading-tight" type="checkbox" :disabled="user.id && user.referral_system ? true : false" v-model="user.referral_system">
        <label for="referral_system_user">
          Referral System Access
        </label>
      </div>
      <div class="w-full md:w-1/3 mt-4 md:mt-0" v-if="systemsAvailable.indexOf('knowledge-hub') !== -1">
        <input id="knowledge_hub_user" class="mr-2 leading-tight" type="checkbox" :disabled="user.id && user.knowledge_hub ? true : false" v-model="user.knowledge_hub">
        <label for="knowledge_hub_user">
          Knowledge Hub Access
        </label>
      </div>
    </div>

    <div class="flex justify-center mt-6">
      <button
        type="submit"
        class="text-sm w-48 px-4 py-2 flex items-center justify-center text-grey-darkest rounded-lg shadow hover:shadow-none border border-blue bg-white leading-none"
        :disabled="selectedOffice === null || saving"
        :class="{ 'opacity-75': selectedOffice === null || saving }"
      >
        Save
      </button>
      <button
        type="button"
        class="ml-10 text-sm w-24 px-4 py-2 flex items-center justify-center text-grey-darkest bg-white leading-none"
        @click="$emit('cancel')"
      >
        Cancel
      </button>
    </div>
  </form>
</template>

<script>
import api from '@/http'
import { mapState } from 'vuex'
import ErrorBag from '@/ErrorBag'

export default {
  props: ['user'],

  data () {
    return {
      saving: false,
      errors: new ErrorBag()
    }
  },

  computed: {
    ...mapState(['selectedOffice', 'system']),

    systemsAvailable () {
      return this.system.external_data.systems_available || []
    }
  },
  methods: {
    save (e) {
      e.preventDefault()
      this.saving = true
      this.errors.clear()

      this.user.office_id = this.selectedOffice.id

      let promise

      if (this.user.id) {
        promise = api.put(`/users/${this.user.id}`, this.user)
      } else {
        promise = api.post('/users', this.user)
      }

      promise
        .then(response => {
          this.saving = false
          this.$emit('saved', response.data)
        })
        .catch(({ response }) => {
          this.errors.store(response.data)
          this.saving = false
        })
    }
  }
}
</script>
